import { nelderMead } from 'fmin/index.js';
import { containedInCircles, intersectionArea } from 'venn.js/src/circleintersection';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var res = 0.0001; // checking accuracy

var Point = /*#__PURE__*/function () {
  function Point() {
    _classCallCheck(this, Point);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var l = args.length;
    this.dim = l === 1 ? args[0].length : l;

    if (l === 1) {
      this.x = args[0][0];
      this.y = args[0][1];
      this.z = this.dim > 2 ? args[0][2] : 0;
    } else {
      this.x = args[0];
      this.y = args[1];
      this.z = this.dim > 2 ? args[2] : 0;
    }
  }

  _createClass(Point, [{
    key: "sum",
    value: function sum(other) {
      if (other instanceof Point) {
        return new Point(this.x + other.x, this.y + other.y, this.z + other.z);
      } else {
        return new Point(this.x + other, this.y + other, this.z + other);
      }
    }
  }, {
    key: "sub",
    value: function sub(other) {
      if (other instanceof Point) {
        return new Point(this.x - other.x, this.y - other.y, this.z - other.z);
      } else {
        return new Point(this.x - other, this.y - other, this.z - other);
      }
    }
  }, {
    key: "mult",
    value: function mult(other) {
      if (other instanceof Point) {
        return new Point(this.x * other.x, this.y * other.y, this.z * other.z);
      } else {
        return new Point(this.x * other, this.y * other, this.z * other);
      }
    }
  }, {
    key: "div",
    value: function div(other) {
      if (other instanceof Point) {
        return new Point(this.x / other.x, this.y / other.y, this.z / other.z);
      } else {
        return new Point(this.x / other, this.y / other, this.z / other);
      }
    }
  }, {
    key: "dist",
    value: function dist(other) {
      return Math.pow(Math.pow(this.x - other.x, 2) + Math.pow(this.y - other.y, 2) + Math.pow(this.z - other.z, 2), 0.5);
    }
  }, {
    key: "std",
    value: function std() {
      return this.dim === 2 ? [this.x, this.y] : [this.x, this.y, this.z];
    }
  }]);

  return Point;
}();

var Circle = /*#__PURE__*/function () {
  function Circle(p, r) {
    _classCallCheck(this, Circle);

    this.c = p; // Point

    this.r = +r; // num
  }

  _createClass(Circle, [{
    key: "touch",
    value: function touch(o) {
      var earthSurface = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var d = this.c.dist(o.c);
      var met = !earthSurface ? this.r + o.r : 180 * (this.r + o.r) / (Earth.R * Math.PI);
      return d < met + res;
    }
  }]);

  return Circle;
}();

var Sphere = /*#__PURE__*/function () {
  function Sphere(c, R) {
    _classCallCheck(this, Sphere);

    this.c = c;
    this.R = R;
  }

  _createClass(Sphere, [{
    key: "gcd",
    value: function gcd(lon1, lat1, lon2, lat2) {
      // Calculate the great circle distance (in meters) between two points on the earth (specified in lng/lat degrees)
      // convert to radians
      var _map = [lon1, lat1, lon2, lat2].map(function (a) {
        return a * Math.PI / 180;
      }),
          _map2 = _slicedToArray(_map, 4),
          _lon1 = _map2[0],
          _lat1 = _map2[1],
          _lon2 = _map2[2],
          _lat2 = _map2[3]; // haversine formula


      var dlon = _lon2 - _lon1;
      var dlat = _lat2 - _lat1;
      var a = Math.pow(Math.sin(dlat / 2), 2) + Math.cos(_lat1) * Math.cos(_lat2) * Math.pow(Math.sin(dlon / 2), 2);
      var c = 2 * Math.asin(Math.sqrt(a));
      return Earth.R * c;
    }
  }]);

  return Sphere;
}();

var Earth = new Sphere(new Point(0, 0, 0), 6378100); // radius in meters

var METERS_PER_DEGREE = Earth.gcd(0, 0, 0, 1);

var sum = function sum(vals) {
  return vals.reduce(function (agg, v) {
    return agg + v;
  }, 0);
};

var avg = function avg(vals) {
  return sum(vals) / vals.length;
};

var dist = function dist(a, b) {
  var geometry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '2d';
  if (geometry === '2d') return Math.pow(Math.pow(a[0] - b[0], 2) + Math.pow(a[1] - b[1], 2), 0.5);
  if (geometry === '3d') return Math.pow(Math.pow(a[0] - b[0], 2) + Math.pow(a[1] - b[1], 2) + Math.pow(a[2] - b[2], 2), 0.5);
  if (geometry === 'earth') return Earth.gcd(a[0], a[1], b[0], b[1]);
};

var calcSumErrors = function calcSumErrors(coords, radiusProportion, circles, geometry) {
  return sum(circles.map(function (_ref) {
    var c = _ref.c,
        r = _ref.r;
    return Math.pow(dist(coords, c.std(), geometry) - r * radiusProportion, 2);
  }));
};

var calcIntersectionArea = function calcIntersectionArea(radiusProportion, circles, geometry, stats) {
  if (!['2d', 'earth'].includes(geometry)) {
    throw new Error("Unsupported geometry: ".concat(geometry));
  }

  var rFactor = radiusProportion / (geometry === 'earth' ? METERS_PER_DEGREE : 1);
  var circleData = circles.map(function (_ref2) {
    var c = _ref2.c,
        r = _ref2.r;
    return {
      x: c.x,
      y: c.y,
      radius: r * rFactor
    };
  });
  return intersectionArea(circleData, stats) * (geometry === 'earth' ? Math.pow(METERS_PER_DEGREE, 2) : 1);
};

var calcIntersectionCentroid = function calcIntersectionCentroid(radiusProportion, circles, geometry) {
  var stats = {};
  calcIntersectionArea(radiusProportion, circles, geometry, stats);
  return ['x', 'y'].map(function (c) {
    return avg(stats.innerPoints.map(function (p) {
      return p[c];
    }));
  });
};

var calcStartingCoords = function calcStartingCoords(circles, geometry) {
  // center coordinates of smallest circle
  var smallestCircle = circles.slice().sort(function (a, b) {
    return a.r - b.r;
  })[0];
  var smallestCircleR = smallestCircle.r / (geometry === 'earth' ? METERS_PER_DEGREE : 1);
  var smallestCircleC = smallestCircle.c; // weighted centroid of all pnts

  var sumR = sum(circles.map(function (p) {
    return p.r;
  }));
  var wCentroid = new Point(0, 0, 0);
  circles.forEach(function (_ref3) {
    var c = _ref3.c,
        r = _ref3.r;
    var weight = (sumR - r) / ((circles.length - 1) * sumR);
    wCentroid = wCentroid.sum(c.mult(weight));
  }); // pick weighted centroid if it's included within the smallest circle radius,
  // otherwise go as far in that direction as ~90% of the smallest radius allows

  var radRatio = Math.min(1, smallestCircleR / smallestCircleC.dist(wCentroid) * 0.9);
  var p0 = wCentroid.mult(radRatio).sum(smallestCircleC.mult(1 - radRatio));
  return p0.std().slice(0, geometry === '3d' ? 3 : 2);
};

var isDisjoint = function isDisjoint(circles, isOnEarthSurface) {
  // does not support sophisticated checking for disjoint area on earth surface mode
  for (var i = 0, l = circles.length; i < l; i++) {
    for (var j = i + 1; j < l; j++) {
      if (!circles[j].touch(circles[i], isOnEarthSurface)) return true;
    }
  }

  return false;
};

var isPntInOverlapArea = function isPntInOverlapArea(pnt, circles, geometry) {
  if (!['2d', 'earth'].includes(geometry)) {
    throw new Error("Unsupported geometry: ".concat(geometry));
  }

  var rFactor = 1 / (geometry === 'earth' ? METERS_PER_DEGREE : 1);
  var pntData = {
    x: pnt[0],
    y: pnt[1]
  };
  var circleData = circles.map(function (_ref4) {
    var c = _ref4.c,
        r = _ref4.r;
    return {
      x: c.x,
      y: c.y,
      radius: r * rFactor
    };
  });
  return containedInCircles(pntData, circleData);
};

function findCoords(circles, _ref5) {
  var _ref5$geometry = _ref5.geometry,
      geometry = _ref5$geometry === void 0 ? '2d' : _ref5$geometry,
      _ref5$method = _ref5.method,
      method = _ref5$method === void 0 ? 'lse' : _ref5$method,
      _ref5$maxIterations = _ref5.maxIterations,
      maxIterations = _ref5$maxIterations === void 0 ? 100 : _ref5$maxIterations;

  if (method === 'lse') {
    return nelderMead(function (coords) {
      return calcSumErrors(coords, 1, circles, geometry);
    }, calcStartingCoords(circles, geometry), {
      maxIterations: maxIterations
    }).x;
  } else if (method === 'lseInside') {
    if (isDisjoint(circles, geometry === 'earth')) {
      throw new Error('Disjointed beacons', circles);
    }

    var startingCoords = calcStartingCoords(circles, geometry);

    var _fmin$x = _toArray(nelderMead(function (_ref6) {
      var _ref7 = _toArray(_ref6),
          radiusProportion = _ref7[0],
          coords = _ref7.slice(1);

      // don't enlarge circles to make it fit
      if (radiusProportion > 1) return Infinity;

      if (geometry === 'earth') {
        var _coords = _slicedToArray(coords, 2),
            lng = _coords[0],
            lat = _coords[1];

        if (Math.abs(lng) > 180 || Math.abs(lat) > 90) return Infinity; // lat, lng out of bounds
      }

      if (!isPntInOverlapArea(coords, circles, geometry)) return Infinity;
      return calcSumErrors(coords, radiusProportion, circles, geometry);
    }, [1].concat(_toConsumableArray(startingCoords)), {
      maxIterations: maxIterations
    }).x),
        coordsLse = _fmin$x.slice(1);

    return coordsLse;
  } else if (method === 'circleSizing') {
    var _fmin$x2 = _slicedToArray(nelderMead(function (_ref8) {
      var _ref9 = _slicedToArray(_ref8, 1),
          radiusProportion = _ref9[0];

      var area = calcIntersectionArea(radiusProportion, circles, geometry);
      return area > 0 ? area : Infinity;
    }, [1], {
      maxIterations: maxIterations
    }).x, 1),
        minRadiusProportion = _fmin$x2[0];

    return calcIntersectionCentroid(minRadiusProportion, circles, geometry);
  }
}

function locate(beacons) {
  var _ref10 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref10$geometry = _ref10.geometry,
      geometry = _ref10$geometry === void 0 ? '2d' : _ref10$geometry,
      _ref10$method = _ref10.method,
      method = _ref10$method === void 0 ? 'lse' : _ref10$method,
      passThroughOpts = _objectWithoutProperties(_ref10, ["geometry", "method"]);

  if (beacons.length < 2) {
    throw new Error("Please provide at least two beacons");
  }

  if (!['2d', '3d', 'earth'].includes(geometry)) {
    throw new Error("Unsupported geometry: ".concat(geometry));
  }

  if (!['lse', 'lseInside', 'circleSizing'].includes(method)) {
    throw new Error("Unsupported method: ".concat(method));
  }

  var circles = beacons.map(function (_ref11) {
    var distance = _ref11.distance,
        coords = _objectWithoutProperties(_ref11, ["distance"]);

    var c = geometry === '2d' ? new Point(coords.x, coords.y) : geometry === '3d' ? new Point(coords.x, coords.y, coords.z) : new Point(coords.lng, coords.lat);
    return new Circle(c, distance); // in Earth mode, gcd distances are specified in meters
  });

  var _findCoords = findCoords(circles, _objectSpread2({
    geometry: geometry,
    method: method
  }, passThroughOpts)),
      _findCoords2 = _slicedToArray(_findCoords, 3),
      x = _findCoords2[0],
      y = _findCoords2[1],
      z = _findCoords2[2];

  if (geometry === 'earth') {
    var lng = x;
    var lat = y; // make lat, lngs uniform

    while (lng > 180) {
      lng -= 360;
    }

    while (lng < -180) {
      lng += 360;
    }

    while (lat > 90) {
      lat -= 180;
    }

    while (lat < -90) {
      lat += 180;
    }

    return {
      lat: lat,
      lng: lng
    };
  }

  return geometry === '2d' ? {
    x: x,
    y: y
  } : {
    x: x,
    y: y,
    z: z
  };
}

export default locate;
